import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee0cb9639da04/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8dee0cb9639da04/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8dee0cb9639da04/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/node_modules/next/dist/client/link.js");
